import type { ProcessedNotificationKind } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { NOTIFICATION_CATEGORIES } from './notificationCategories';
import { cn } from '~/utils/cnTailwind';

type Props = {
    kind: ProcessedNotificationKind;
    children: React.ReactNode;
    /** Extra classes for the group container (e.g. to collapse the group while it has no rows). */
    className?: string;
    /** Ref to the rows container, used by the processed tab to detect when every row rendered nothing. */
    rowsRef?: React.Ref<HTMLDivElement>;
};

/** Renders a single category heading (icon + title) followed by all of its notification rows. */
export const NotificationGroup: React.FC<Props> = ({ children, className, kind, rowsRef }) => {
    const { t } = useTranslation();
    const { icon, iconClassName, iconContainerClassName, titleKey } = NOTIFICATION_CATEGORIES[kind];

    return (
        <div className={cn('flex flex-col gap-3 py-4', className)} data-notification-group>
            <div className="flex items-center gap-3">
                <div className={cn('flex items-center justify-center size-6 rounded shrink-0', iconContainerClassName)}>
                    <span className={cn('text-sm', iconClassName)}>{icon}</span>
                </div>
                <span className="text-base font-medium text-midnight">{t(titleKey)}</span>
            </div>
            <div ref={rowsRef} className="flex flex-col gap-2">
                {children}
            </div>
        </div>
    );
};
